import { render } from "./EventEdit.vue?vue&type=template&id=3dd3d784"
import script from "./EventEdit.vue?vue&type=script&lang=js"
export * from "./EventEdit.vue?vue&type=script&lang=js"
script.render = render

export default script